<script>
import { Line, mixins } from 'vue-chartjs'
import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import _ from 'underscore'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ['height'],
  mounted () {
    if (!this.chartData) return;
    const brandInfo = '#5164a9'
    const brandDanger = '#f86c6b'
    const brandInfoLight = '#63c2de'
    const brandSuccess = '#3ea662'
    const brandWarning = '#ffc107'

    let allValues = _.union(this.chartData.assinaturas, this.chartData.autenticacoes, this.chartData.carimbosTempo, this.chartData.assinaturasHub, this.chartData.autenticacoesHub);
    let yAxesMax = allValues.length ? Math.max(...allValues) + 1 : 1;

    let datasets = [
      {
        label: 'Assinaturas',
        backgroundColor: "#f4f4f6",
        borderColor: brandInfo,
        pointHoverBackgroundColor: '#fff',
        borderWidth: 2,
        data: this.chartData.assinaturas
      },
      {
        label: 'Autenticações',
        backgroundColor: 'transparent',
        borderColor: brandDanger,
        pointHoverBackgroundColor: '#fff',
        borderWidth: 2,
        data: this.chartData.autenticacoes
      }
    ]

    let totalCarimbos = (this.chartData.carimbosTempo || []).reduce((acum, curr) => acum + curr, 0)
    let totalAssinaturasHub = (this.chartData.assinaturasHub || []).reduce((acum, curr) => acum + curr, 0)
    let totalAutenticacoesHub = (this.chartData.autenticacoesHub || []).reduce((acum, curr) => acum + curr, 0)

    if (totalCarimbos > 0) {
      datasets.push({
        label: 'Carimbos Tempo',
        backgroundColor: 'transparent',
        borderColor: brandInfoLight,
        pointHoverBackgroundColor: '#fff',
        borderWidth: 2,
        data: this.chartData.carimbosTempo
      })
    }
    if (totalAssinaturasHub > 0 || totalAutenticacoesHub > 0) {
      datasets.push({
        label: 'Assinaturas HUB',
        backgroundColor: "transparent",
        borderColor: brandSuccess,
        pointHoverBackgroundColor: '#fff',
        borderWidth: 2,
        data: this.chartData.assinaturasHub
      })
      datasets.push({
        label: 'Autenticações HUB',
        backgroundColor: 'transparent',
        borderColor: brandWarning,
        pointHoverBackgroundColor: '#fff',
        borderWidth: 2,
        data: this.chartData.autenticacoesHub
      })
    }

    this.renderChart({
      labels: this.chartData.labels,
      datasets
    }, {
      tooltips: {
        enabled: false,
        custom: CustomTooltips,
        intersect: true,
        mode: 'index',
        position: 'nearest',
        callbacks: {
          labelColor: function (tooltipItem, chart) {
            return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor }
          }
        }
      },
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          gridLines: {
            drawOnChartArea: false
          }
        }],
        yAxes: [{
          ticks: {
            beginAtZero: true,
            maxTicksLimit: 5,
            stepSize: Math.ceil(yAxesMax / 5),
            max: yAxesMax
          },
          gridLines: {
            display: true
          }
        }]
      },
      elements: {
        point: {
          radius: 0,
          hitRadius: 10,
          hoverRadius: 4,
          hoverBorderWidth: 3
        }
      }
    })
  }
}
</script>
